import './bootstrap';

import general from './containers/general';

general();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(() => {
      // Registration was successful
    }, (err) => {
      console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
    });
  });
}
